import { ThemeOptions } from '@mui/material/styles'

export const darkTheme: ThemeOptions = {
  palette: {
    mode: 'dark',
    background: {
      paper: '#0d1117',
      default: '#161b22',
    },
    text: {
      primary: '#FFFFFF',
      secondary: '#c9d1d9',
    },
  },
}
